import { StyleSheet, Platform, Dimensions } from 'react-native';
import { moderateScale } from 'react-native-size-matters';

import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
const width = Dimensions.get('window').width;
const isMobile = width <= 550;

export const styles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    backgroundColor: '#f4f4f4',
    borderWidth: 1,
    borderColor: Theme.GREY,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    marginVertical: defaultScale(10),
    padding: defaultScale(10),
    flexDirection: 'column',
  },
  activeCardContainer: {
    borderLeftColor: Theme.PRIMARY,
    borderLeftWidth: 5,
  },
  cardHeader: {
    flexDirection: 'row',
  },
  iconContainer: {
    marginRight: defaultScale(5),
    width: defaultScale(27),
    height: defaultScale(24),
  },
  bodyGroupIconContainer: {
    marginRight: defaultScale(5),
    width: defaultScale(27),
    height: defaultScale(24),
  },
  cogIconContainer: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.GREY_LIGHT,
  },
  settingsIconContainer: {
    marginRight: 5,
    justifyContent: 'center',
  },
  headerContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  titleContainer: {
    justifyContent: 'center',
  },
  title: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.CHARCOAL,
  },
  activeTitle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
  },
  subtitleInnerContainer: {
    justifyContent: 'flex-end'
  },
  subtitle: {
    ...Theme.textStyle.small,
    justifyContent: 'flex-end',
    color: Theme.GREY_DARK_MEDIUM
  },
  description: {
    ...Theme.textStyle.small,
    color: Theme.GREY_DARK_MEDIUM
  },
  arrowContainer: {
    padding: 10,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    justifyContent: 'center',
    backgroundColor: Theme.PRIMARY,
  },
  verticalSeparator: {
    width: 2,
    marginHorizontal: 7,
    backgroundColor: Theme.GREY_LIGHT,
  },
  subtitleContainer: {
    flexDirection: 'row'
  },
  settingsHeader: {
    fontSize: moderateScale(14, 1),
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  settingsSavedContainer: {
    flexDirection: 'row',
  },
  settingsSaved: {
    flex: 1,
    textAlign: 'right',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  fullBodyEmphasis: {
    textAlign: 'center',
    ...Platform.select({
      web: {
        textAlign: isMobile ? 'center' : 'left',
      }
    }),
  },
  innerSettingsSectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  settingsButton: {
    flex: 1,
    flexBasis: 0,
    paddingVertical: moderateScale(3, 2),
    flexDirection: 'row',
  },
  buttonInformationContainer: {
    flex: 1,
  },
  settingsRadioContainer: {
    paddingRight: 7,
    justifyContent: 'center',
  },
  settingCheckboxContainer: {
    justifyContent: 'center',
  },
  settingsImageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  settingContainerWithDescription: {
    flex: 1,
  },
  settingDescription: {
    textAlign: 'center',
  },
  settingsImage: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
    marginRight: 5,
  },
  settingsTitle: {
    fontSize: moderateScale(13, 1),
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  updatedText: {
    alignSelf: 'center',
  },
  settingsSubtitle: {
    fontSize: moderateScale(9, 2),
    color: Theme.GREY_MEDIUM,
    fontFamily: Theme.Custom500,
    ...Platform.select({
      web: {
        fontSize: 14,
        fontFamily: Theme.Custom500,
      },
    }),
  },
  partnerName: {
    color: Theme.PRIMARY,
  },
  gymDropdownContainer: {
    zIndex: 1,
    borderBottomColor: Theme.GREY_LIGHT,
    borderBottomWidth: 0,
    paddingVertical: 0,
    width: defaultScale(340), // based on 2x button width and their margins
  },
  dropdownContainer: {
    flexDirection: 'row',
    padding: 8,
    marginVertical: 10,
    backgroundColor: Theme.GREY_LIGHT,
    borderRadius: 5,
    ...Platform.select({
      web:  {
        maxWidth: '100%',
        padding: 0,
      },
    }),
  },
  bodyGroupSectionContainer: {
    ...Platform.select({
      default: {
        paddingTop: moderateScale(5, 2),
      },
      web: {
        paddingTop: 20,
      }
    }),
  },
  bodyGroupImageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        flex: isMobile ? 0.3 : 0.7,
        flexBasis: 0,
      },
    }),
  },
  bodyGroupButton: {
    flex: 1,
    flexDirection: 'row',
  },
  bodyGroupOptions: {
    ...Platform.select({
      default: {
        marginTop: -15,
      },
      web: {
        marginTop: isMobile ? 0 : -15,
      },
    }),
  },
  bodyGroupSelectionContainer: {
    justifyContent: 'space-around',
    ...Platform.select({
      web: {
        flex: isMobile ? 0.7 : 0.7,
        justifyContent: 'flex-start',
        flexBasis: 0,
      },
    }),
  },
  bodyGroupImage: {
    resizeMode: 'contain',
    ...Platform.select({
      default: {
        width: moderateScale(120, 2),
        height: moderateScale(120, 2),
      },
      android: {
        width: moderateScale(100, 2),
        height: moderateScale(100, 2),
      },
      web: {
        width: '100%',
        height: '100%',
      },
    }),
  },
  settingsLoadingIndicator: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  bodyRadioButtonContainer: {
    marginRight: 15,
  },
  moreText: {
    color: Theme.PRIMARY
  }
});

export const largeStyles = StyleSheet.create({
  settingsContainer: {
    paddingVertical: moderateScale(8, 2),
  },
  workoutSettingsContainer: {
    marginLeft: '30%',
  },
  leftSettingsContainer: {
    flex: 1,
    flexBasis: 0,
  },
  skillLevelRowContainer: {
    marginLeft: '15%',
  },
});

export const smallWebStyles = StyleSheet.create({
  settingsContainer: {
    paddingVertical: moderateScale(5, 2),
    ...Platform.select({
      android: {
        paddingVertical: moderateScale(2, 2),
      }
    })
  },
  workoutSettingsContainer: {
    marginLeft: 0,
  },
  leftSettingsContainer: {
    flex: 1,
    flexBasis: 0,
  },
  skillLevelRowContainer: {
    marginLeft: 0,
  },
});

export const getResponsiveStyleSheet = () => {
  return width <= 1024 ? smallWebStyles : largeStyles;
};
